import produce from 'immer'
import React, { FC, useState } from 'react'
import { Modal, Form, Row } from 'react-bootstrap'
import { languages } from '../../utils/constants'
import Select from 'react-select'

export interface CommonPrintModel {
  language: string
  type: string
}

export interface Props {
  onConfirm?: any
  onCancel?: any
  title: string
}

const CommonPrintModal: FC<Props> = ({ onConfirm, onCancel, title }) => {
  const [data, setData] = useState({} as CommonPrintModel)

  const checkDisable = () => {
    if (data.language == '') {
      return true
    }
    return false
  }

  const handleClick = () => {
    console.log(data)
    onConfirm(data)
  }
  return (
    <Modal
      size="lg"
      show={true}
      onHide={onCancel}
      aria-labelledby="example-modal-sizes-title-sm"
      dialogClassName="custom-modal-layout"
      contentClassName="custom-modal-content"
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        className="custom-modal-header"
      >
        <Modal.Title id="example-modal-sizes-title-sm">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Form.Group className="mb-3" controlId="formLanguage">
              <Form.Label>Language</Form.Label>
              <Select
                options={languages}
                onChange={(selectedOption) => {
                  const newData = produce(data, (draft) => {
                    draft.language = selectedOption ? selectedOption.value : ''
                  })
                  setData(newData)
                }}
              />
            </Form.Group>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button
          disabled={checkDisable()}
          className={`${checkDisable() ? 'disable-button' : 'save-button'}`}
          onClick={handleClick}
        >
          Print
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default CommonPrintModal
